import Button, { ButtonProps } from './Button';

export default Button;

export type { ButtonProps };
